import { ADMIN, CONTROL } from '@rootCommon/constants/common';
import { RECOVERY_BIN_RECORD } from '@rootCommon/constants/end-points';
import CrudRequest from '@rootCommon/services/crud-request';
import { BaseMessageDto, MultipleIds } from '@rootTypes/common';
import { RecoveryBinPatientsRequest, RecoveryBinPatientsResponse } from '@rootTypes/recovery-bin';

class RecoveryBinRecordService {
  private getDeletedPatients = async (
    params: RecoveryBinPatientsRequest, url: string,
  ): Promise<RecoveryBinPatientsResponse> => {
    const res = await CrudRequest.get<RecoveryBinPatientsResponse>(`${RECOVERY_BIN_RECORD}/all/${url}`, { params });

    return res.data;
  };

  private deletePatientsPermanently = async (ids: MultipleIds, url: string): Promise<BaseMessageDto> => {
    const res = await CrudRequest.delete<BaseMessageDto>(`${RECOVERY_BIN_RECORD}/${url}`, { data: ids });

    return res.data;
  };

  private recoverPatients = async (ids: MultipleIds, url: string): Promise<BaseMessageDto> => {
    const res = await CrudRequest.put<BaseMessageDto, MultipleIds>(`${RECOVERY_BIN_RECORD}/recover/${url}`, ids);

    return res.data;
  };

  getDeletedPatientsAdmin = (params: RecoveryBinPatientsRequest) => this.getDeletedPatients(params, ADMIN);

  getDeletedPatientsControl = (params: RecoveryBinPatientsRequest) => this.getDeletedPatients(params, CONTROL);

  deletePatientsPermanentlyAdmin = (ids: MultipleIds) => this.deletePatientsPermanently(ids, ADMIN);

  deletePatientsPermanentlyControl = (ids: MultipleIds) => this.deletePatientsPermanently(ids, CONTROL);

  recoverPatientsAdmin = (ids: MultipleIds) => this.recoverPatients(ids, ADMIN);

  recoverPatientsControl = (ids: MultipleIds) => this.recoverPatients(ids, CONTROL);
}

export default new RecoveryBinRecordService();
